import AppSplashScreen from "components/AppSplashScreen";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import AppRoutes from "routes";
import { useDispatch, useSelector } from "store";
import {
  selectAuthIsLoggedIn,
  selectAuthUser,
  selectIsOrganizationLoading,
  selectOrganization,
} from "store/selectors";
import { getProfileAddresses } from "store/slices/profileAddresses/profileAddressesSlice";
import { initMetaPixel, setUserForTracking, trackEvent } from "tracking";
import { checkIsHomeServiceOrganization } from "utils/organization";

const TRACKING_ID = "G-NM0202GTDP"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

export default function App() {
  const dispatch = useDispatch();

  const organization = useSelector(selectOrganization);
  const user = useSelector(selectAuthUser);
  const isLoggedIn = useSelector(selectAuthIsLoggedIn);
  const isOrganizationLoading = useSelector(selectIsOrganizationLoading);

  useEffect(() => {
    if (isLoggedIn) {
      ReactGA.set({ userId: user?.email });
    }
  }, [isLoggedIn, user?.email]);

  useEffect(() => {
    if (!organization?.metaPixelEnabled || !organization?.metaPixelId) return;

    const matching = user
      ? {
          em: user.email,
          ph: user.phoneNumber,
          fn: user.firstName,
          ln: user.lastName,
          external_id: user.id,
        }
      : null;

    void initMetaPixel(organization.metaPixelId, matching);
  }, [organization?.metaPixelEnabled, organization?.metaPixelId, user]);

  useEffect(() => {
    if (organization?.id && organization?.name) {
      trackEvent("Organization Visited", { id: organization.id, name: organization.name }, {});
    }
  }, [organization]);

  if (organization && organization?.id && organization?.name && user) {
    setUserForTracking(user, {
      id: organization.id,
      name: organization.name,
      metaPixelId: organization.metaPixelId,
    });
  }

  const isHomeService = checkIsHomeServiceOrganization(organization.industry!);

  useEffect(() => {
    if (isHomeService && isLoggedIn) {
      dispatch(getProfileAddresses({}));
    }
  }, [isHomeService, isLoggedIn, dispatch]);

  if (isOrganizationLoading) return <AppSplashScreen />;

  return <AppRoutes />;
}
